import axios from 'axios'
// import { Message } from 'element-ui'

const service = axios.create({
	baseURL: process.env.VUE_APP_PREFIX_API, // url = base url + request url
	withCredentials: false, // send cookies when cross-domain requests
	timeout: 5000 // request timeout
})

service.interceptors.request.use(
	(config) => {
		// config.headers['X-Cm-Admin-Auth'] = 'eHTnGQhMsiPpNRKh'
		return config
	}
	// (error) => {
	// 	console.log(error) // for debug
	// 	return Promise.reject(error)
	// }
)

service.interceptors.response.use(
	(response) => {
    const res = response.data
		if (res.resp_common && parseInt(res.resp_common.ret) !== 0) {
      // Message is better than Promise.reject(error)
			// Message({
			// 	message: res.resp_common.msg || 'Error',
			// 	type: 'error',
			// 	duration: 5 * 1000
      // })
      return Promise.reject(error)
		} else {
      return res
		}
	},
	(error) => {
		console.log('err' + error) // for debug
		// Message({
		// 	message: error.message,
		// 	type: 'error',
		// 	duration: 5 * 1000
		// })
		return Promise.reject(error)
	}
)

export default service
